export default __webpack_public_path__ + "media/titles/title_1_locale_it-44a5a2a5.png";